// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"224":"6cc5fbdf","366":"ee0d78b0","754":"455fc7b7","871":"fea07235"}[chunkId] + ".css";
};